import Vue from 'vue'
import vuetify from './plugins/vuetify'
import { VApp } from "vuetify/lib";
import axios from "axios";
import VueAxios from 'vue-axios'
import vueCustomElement from 'vue-custom-element'
import Search from '@/components/NewSearch.vue'

Vue.prototype.$prodPrefix = process.env.VUE_APP_FRONTEND_BASE_URL;
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_BASE_URL

Vue.use(vueCustomElement);
Vue.use(VueAxios, axios);

// Search component
Vue.customElement('iupac-search-custom-element', {
    vuetify: vuetify,
    components: { VApp, Search },
    template: `<v-app id='app'><search></search></v-app>`
})